import i18n from "../language/i18n";

// Singular under a count of exactly 1 ("1 day", not "1 days"). Turkish uses
// the same word either way, so only English reads differently.
const unit = (count: number, singularKey: string, pluralKey: string): string =>
  `${count} ${i18n.t(count === 1 ? singularKey : pluralKey)}`;

// Human-readable "5 gün 3 saat 20 dakika" for a millisecond duration, used for
// begin-countdowns ("Başlamasına …") and the "Kalan süre" deadline across the
// Ödevler and Çalışmalar surfaces so they read identically.
//
// Leading zero units are dropped: a sub-day duration reads "3 saat 20 dakika",
// a sub-hour one just "20 dakika". When days are present, all three parts show
// (per product: "5 gün xx saat yy dakika"). Minutes always show so a short
// countdown never renders empty; a still-positive sub-minute remainder is floored
// UP to "1 dakika" rather than the misleading "0 dakika".
export const formatRemainingDuration = (millisRemaining: number): string => {
  const clamped = Math.max(0, millisRemaining);
  const totalMinutes = Math.floor(clamped / 60000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  let minutes = totalMinutes % 60;
  // >0 but under a minute would floor to 0 across every unit → show "1 dakika".
  if (clamped > 0 && days === 0 && hours === 0 && minutes === 0) {
    minutes = 1;
  }
  const parts: string[] = [];
  if (days > 0) parts.push(unit(days, "duration_day", "duration_days"));
  if (days > 0 || hours > 0) parts.push(unit(hours, "duration_hour", "duration_hours"));
  parts.push(unit(minutes, "duration_minute", "duration_minutes"));
  return parts.join(" ");
};
